
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/la-famiglia-charrere",
      function () {
        return require("private-next-pages/la-famiglia-charrere.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/la-famiglia-charrere"])
      });
    }
  